module.exports = __webpack_public_path__ + "img/IvoryCell.81afa060.png";